<template>
  <div class="presentation-container page-content">
    <div class="w-100 px-5 py-2" style="background-color: #3281bc;">
      <img src="../../../public/assets/images/orep-white-logo.png"  height="63" width="220" alt="Logo">
    </div>
    <div class="input-section">
      <div class="mb-4">      
        <div class="row justify-content-between align-items-center">
          <h4 class="col-md-8">
            Thank you for submitting your application to OREP, we will review your application and send your Quote within two (2) business days.
            If you have any questions, please email <a target="_blank" href="mailto:investigators@orep.org" style="font-size: 20px; color: #3d85c6;">investigators@orep.org</a>
            or call <strong>888-347-5273</strong>.
          </h4>
          <img src="../../../public/assets/images/call.png" class="img-call col-md-4" style="width: 250px;" alt="Logo">
        </div>
      </div>
      <div class="mb-4 footer">
        <p class="mt-3 strong">OREP</p>
        <p>6353 El Cajon Blvd, Suite 124-605</p>
        <p>San Diego, CA 92115 </p>
        <p>(888) 347-5273</p>
        <p>investigators@orep.org</p>
        <p>OREP Insurance Services, LLC. Calif. Lic. #0K99465</p>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "rc-application-representation",
  computed: {
    rcApplication() {
      return this.$store.state.rcApplication.rcApplication;
    },
    state() {
      return this.$store.state.rcApplication;
    },
    errorMsg() {
      return this.$store.state.rcApplication.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/rc-application-amba/' || this.rcApplication.customer.partnerName === 'Mercer'){
        return 'Mercer';
      }else if (first === '/portal/rc-application-realshield/' || this.rcApplication.customer.partnerName === 'Realshield'){
        return 'Realshield';
      }else {
        return 'OREP';
      }
    },
  },

  mounted() {
    $('html, body').animate({
      scrollTop: $('.presentation-container').offset().top
    }, 500);
  },
}
</script>

<style scoped>
.container {
  background-color: white !important;
  padding-bottom: 30px;
}
.img-call {
  height: 170px;
  max-height: 170px;
}
p {
  margin: 5px 0;
}
.strong {
  font-weight: bold !important;
}
table td {
  padding: 0 5px !important;
}
table > tbody > tr > td:first-child {
  width: 35%
}
table > tbody > tr > td:last-child {
  width: 65%
}


.table-bordered td {
  vertical-align: top;
  border-right: 2px solid #dee2e6;
  border-left-width: 0;
  border-bottom-width: 0;
  border-top-width: 0;
}
</style>
